module.exports = __webpack_public_path__ + "img/img-156.96a5a46e.png";